module.exports = __webpack_public_path__ + "img/businessman2.17e8d3e8.svg";